import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  palette,
  spaceLarge,
  spaceXLarge,
}: Theme) => ({
  root: {
    padding: `0 0 ${spaceXLarge}`,
    background: palette.primary.dark,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4rem',
    paddingTop: spaceLarge,
    borderTop: `1px solid ${palette.grey[50]}`,
  },
}));
